
export enum ItemStatusTypes {
	Open = 1,
	Closed = 2,
	Search = 3
}

export enum QuickViewQueryType {
	ItemStatus = 1,
	DueStatus = 2
}


export enum OwnershipTypes {
	AssignedToMe = 1,
	OwnedByMe = 2,
	All = 3,
}

export enum EntityStatusCodes {
	All = 'ALL',
	Active = 'ACTIVE',
	Archived = 'ARCHIVE',
	Trashed = 'TRASHED'
}

export enum EntityStatuses {
	All = 0,
	Active = 1,
    Archived = 2,
    Trashed = 3
}

export enum ItemStatuses {
    New = 1,
    InProgress = 2,
    Completed = 3,
    OnHold = 4,
    Unapproved = 5,
    Submitted = 6,
    Approved = 7,
    Rejected = 8,
    Closed = 9,
    Bugged = 10,
    Overdue = 11
}

export enum CloseStatuses {
	All = 0,
	Open = 1,
	Closed = 2,
	Cancelled = 3
}

export enum ItemTypes {
    Root = 1,
    Folder = 2,
    Task = 3,
	Kanban = 4,	
	SupportTicket = 5
}